import type { TourDefinition } from '../training/tours';

/**
 * Тур картки замовлення «Відпрацювання» (/legal/matters/:id). Ідентифікатор для реєстрації: 'legal-matter'.
 * Цілі — атрибути data-tour у картці замовлення (features/legal/pages/MatterPage.tsx, features/legal/matters/*).
 */
export const LEGAL_MATTER_TOUR_ID = 'legal-matter';

export const LEGAL_MATTER_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Картка замовлення',
  summary: 'Стадії з умовами переходу, строки з причиною перенесення, шлюз старту, контроль якості Q1–Q3 і пакет завершення.',
  missingHint: 'Відкрийте замовлення в розділі «Юридичний контур» → «Замовлення» — підказки прив’яжуться до його картки.',
  steps: [
    {
      id: 'card',
      target: 'legal-matter-head',
      title: 'Замовлення',
      body: 'Номер, клієнт, послуга, ваші ролі в замовленні й позначки. Редагування, посилання й активація чернетки з CRM — у шапці картки.',
      placement: 'bottom',
    },
    {
      id: 'stage',
      target: 'legal-matter-stage',
      title: 'Стадія',
      body: 'Замовлення рухається лише за процесом. Перед переходом система просить коментар за формулою і відповіді на контрольні питання стадії; недоступні стадії пояснюють чому.',
      placement: 'bottom',
    },
    {
      id: 'dates',
      target: 'legal-matter-dates',
      title: 'Строки',
      body: 'Базовий строк змінюється лише через запит на зміну; плановий переносять із причиною і коментарем. Після трьох перенесень з вини клієнта система пропонує стадію «Підвисло».',
    },
    {
      id: 'gate',
      target: 'legal-matter-tab-gate',
      title: 'Документи й старт',
      body: 'Шлюз готовності перевіряє документи, оплату й обсяг. Строк рахується від готовності повного пакета, а не від оплати; старт без повної оплати — лише після погодження винятку.',
      placement: 'bottom',
    },
    {
      id: 'quality',
      target: 'legal-matter-tab-quality',
      title: 'Якість',
      body: 'Рівень контролю: Q1 — самоперевірка, Q2 — інший юрист, Q3 — керівник практики чи експерт. Перевіряльник не може бути виконавцем.',
      placement: 'bottom',
    },
    {
      id: 'complete',
      target: 'legal-matter-tab-complete',
      title: 'Завершення',
      body: 'Закриття основної задачі не завершує замовлення. Пройдіть пакет завершення: юридична частина, фінальний контакт, завершення, закриття в CRM і фінансах з перевіркою керівника.',
      placement: 'bottom',
    },
  ],
};
